<template>
	<v-dialog :fullscreen="isMobile" v-if="open" v-model="open" max-width="700px" scrollable>
		<v-card raised>
			<v-card-title>
				<button type="button" class="btn-flat-icon--dark" @click="open = false">
					<v-icon medium>fal fa-times</v-icon>
				</button>
				<v-spacer></v-spacer>
				<button type="button" class="btn-flat-icon--dark" @click="likeCoHost">
					<v-icon medium>fal fa-heart</v-icon>
				</button>
			</v-card-title>
			<v-card-text class="pt-0 pl-4 pr-4 event-page__modal-card-text text-xs-center" v-if="event.cohosts[cohostModalIndex]">
				<div>
					<div>
						<div class="event-page-host-container" style="margin-bottom: -16px;">
							<div class="host-divider">
							</div>
							<div class="white host-circle">
								<div :style="{'background-image': 'url(' + (event.cohosts[cohostModalIndex].user.avatar_lg || event.cohosts[cohostModalIndex].user.avatar) + ')'}" class="host-image"></div>
							</div>
						</div>
					</div>
					<p class="event-page-content-light">
						<b>{{event.cohosts[cohostModalIndex].user.first_name}}</b>
					</p>
					<p class="event-page-content" style="padding: 0px 10%;">
						{{event.cohosts[cohostModalIndex].description}}
					</p>
				</div>
				<div>
					<img class="event-page-flat-logo mb-3 mt-3" src="/static/images/wrkprty-flattened-logo.png" alt="">
					<p class="event-page-sub-heading-small mb-3"><a @click="reportEventModal=true">Report this Location, Event, or Host</a></p>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { segmentTrack } from '~/plugins/segment'
export default {
	name: 'eventCohostModal',
	methods: {
		...mapActions(['setModalOpen']),
		likeCoHost() {
			let cohost = this.event.cohosts[this.cohostModalIndex]
			segmentTrack('favorite_cohost', {
				label: cohost.user.first_name + ' ' + cohost.user.last_name,
				value: cohost.pk
			})
		}
	},
	computed: {
		...mapGetters(['getModalProp']),
		open: {
			get() {
				return this.getModalProp('eventCohostModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'eventCohostModal', value: val })
			}
		},
		reportEventModal: {
			get() {
				return this.getModalProp('eventReportEventModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'eventReportEventModal', value: val })
			}
		},
		event() {
			return this.getModalProp('eventModalEvent')
		},
		cohostModalIndex() {
			return this.getModalProp('eventCohostModalIndex')
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	}
}
</script>
